import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetSimXTaxonomiesResponse } from '../models/responses/get-simx-taxonomies-response.model';
import { GetSimXTaxonomyResponse } from '../models/responses/get-simx-taxonomy-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class TaxonomyDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getAllTaxonomies(): Observable<GetSimXTaxonomiesResponse> {
    const url = this._dataService.taxonomiesUrl();
    return this._http.get<GetSimXTaxonomiesResponse>(url);
  }

  getTaxonomyByName(taxonomy: string): Observable<GetSimXTaxonomyResponse> {
    const url = this._dataService.taxonomiesUrl(taxonomy);
    return this._http.get<GetSimXTaxonomyResponse>(url);
  }
}
